const dropdown = () => {
    return {
        open: false,
        options: [],
        value: '',
        text: '',

        init() {
            this.options = this.$refs.select.children;
            this.value   = this.$refs.select.value;

            const selectedOption = this.getSelectedOption();
            this.text            = selectedOption?.text;
    
            this.$watch('value', () => {
                const selectedOption = this.getSelectedOption();
                this.text            = selectedOption?.text;
            });
        },

        getSelectedOption()
        {
            return this.options.length > 0 ? this.options[this.$refs.select.selectedIndex] : {};
        },

        toggle()
        {
            this.open = !this.open;
        },

        close()
        {
            this.open = false;
        },

        update()
        {
            this.value = this.$event.detail;
        },

        refreshOptions()
        {
            this.options = [];

            setTimeout(() => {
                this.options = this.$refs.select.children;

                const selectedOption = this.getSelectedOption();
                this.text            = selectedOption?.text;
            }, 250);
        },

        click(option) {
            if (option.disabled) {
                return;
            }

            option.click();

            if (this.$refs.select.value === option.value) {
                return;
            }

            this.$refs.select.value = option.value;

            this.$refs.select.dispatchEvent(new Event('change', { bubbles: true }));
        },

        optionClasses(option)
        {
            var classes = this.isSelected(option) ? 'font-bold' : 'text-white';

            return option.disabled ? classes + ' cursor-not-allowed' : classes;
        },

        optionStatus(option)
        {
            return option.disabled ? 'text-neutral-400' : 'text-neutral-700';
        },

        isSelected(option)
        {
            return this.value == option.value;
        },

        borderClasses()
        {
            return this.open ? 'rounded-b-none' : 'rounded-b-md';
        },

        onlyForPremium(option)
        {
            return Boolean(option.getAttribute('onlyForPremium'));
        }
    }
}

export default dropdown;
